function FinalCtaSection() {
  return (
    <section data-ga-section="final_cta" className="bg-darkrock text-white py-20 relative overflow-hidden">
      <div className="absolute top-10 left-10 w-32 h-32 rounded-full bg-white/5 blur-2xl" />
      <div className="absolute bottom-10 right-10 w-48 h-48 rounded-full bg-primary-600/20 blur-3xl" />
      <div className="max-w-screen-lg mx-auto px-6 text-center relative">
        <div className="font-mono text-[11px] tracking-[0.18em] text-white/50 uppercase">Get started</div>
        <h2
          className="iv1-font-display text-3xl sm:text-5xl font-bold mt-2 leading-tight"
          style={{ textWrap: "balance" }}
        >
          Ready to transform screen time into learning time?
        </h2>
        <p className="mt-4 text-white/70 text-lg max-w-xl mx-auto" style={{ textWrap: "pretty" }}>
          Join Learnforest and give your child a focused, engaging, and parent-friendly learning experience.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <a
            href="https://student.learnforest.app"
            data-ga-cta="student_signin"
            className="bg-primary-600 hover:bg-primary-700 text-white font-semibold px-8 py-3 rounded-xl text-lg transition-colors text-center"
          >
            Student sign-in
          </a>
          <a
            href="https://parent.learnforest.app/"
            data-ga-cta="parent_signin"
            className="border-2 border-white/30 hover:border-white/70 text-white font-semibold px-8 py-3 rounded-xl text-lg transition-colors text-center"
          >
            Parent sign-in
          </a>
        </div>
      </div>
    </section>
  );
}

export default FinalCtaSection;
